import { gql } from '@apollo/client';

export const postProvinciaCompras = gql`
mutation ProvinciaComprasRQ{
    ProvinciaComprasRQ(input: $input)  
        @rest(type: "ProvinciaComprasRS", path: "/api/gateway/formularios/AdhesionProvinciaCompras",  method: "post"){
            
            resultado
            error
            stackTrace
        }
}
`